$(document).ready(function(){
  $('.collapsible').collapsible()
  $('.parallax').parallax()
})
